"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enable = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../../actions");
var initialState = {
  loading: false
};
var enable = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.enableWithdraw2faAction.pending, function (state) {
    state.loading = true;
  });
  builder.addCase(_actions.enableWithdraw2faAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.enableWithdraw2faAction.fulfilled, function (state) {
    state.loading = false;
  });
});
exports.enable = enable;